import { CSSProperties } from "react";
import { XTypography } from "./XTypography";

export const XStringWithNode = ({
  string,
  children,
  spacing = 2,
  style,
}: {
  string: string;
  children: React.ReactNode;
  spacing?: number;
  style?: CSSProperties;
}) => {
  return (
    <div style={{ display: "flex", alignItems: "center", ...style }}>
      <XTypography style={{ marginRight: spacing }}>{string}</XTypography>
      {children}
    </div>
  );
};
